















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState } from '../store';
import Sidebar from "../components/Sidebar.vue";
import ContactSidebar from "../components/Contact_sprint2/contact_sidebar.vue";
import ContactTable from "../components/Contact_sprint2/contact_table.vue";
import ContactNew from "../components/Contact_sprint2/Contact_New.vue";
import ContactEdit from "../components/Contact_sprint2/Contact_Edit.vue";
import TagCRUD from  '../components/Tag/TagCRUD.vue';
import { mapState } from 'vuex';

 @Component({
  components: {
     Sidebar,ContactSidebar,ContactTable,ContactNew,ContactEdit,TagCRUD
  },
  computed: {
  ...mapState({
    'Tag_status': (state: StoreState) => state.dashboard.Tag_status,
    'contactsidebar_status': (state: StoreState) => state.dashboard.contactsidebar_status,
    'textpannel_contactinfo': (state: StoreState) => state.dashboard.textpannel_contactinfo ,
    'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
  }),


  }
 })
export default class ContacSp2 extends Vue {
 data() {
 return {
  TAB_status:false,
  NewContact:false,
  EditContact:false
 }
 }

 tabmanag(ev){
   console.log('evt',ev);
   console.log('contactsidebarselected here',(this as any).contactsidebar_status);
       this.$store.commit("TAB_MANAG",{evt:ev, type:ev.type});
  }

  NewCOntact(){
    this.$data.NewContact=true;
  }

  EditContact_evntt(){
    //this.$store.commit("SET_SELECTED_CONTACTS", contc);
    this.$data.EditContact=true;
  }

  refresh(evt,data){ console.log('deleting tag called');
    (this.$refs.refreshlist as any).refreshcontact(evt,data);
  }

  editclose_evet(evt){
    this.$data.EditContact=false;
    (this.$refs.refreshlist as any).refreshcontact(evt);
  }

 updatecontactInfo(evt){
   if((this as any).contactsidebar_status=='favorites'){
        // this.$data.EditContact=false;
     }
    (this.$refs.refreshlist as any).refreshcontact(evt);
 }
}
